import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';
import type { User } from '@klp/user';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_SAK_ENABLE: boolean;
        WEBAPP_API_NE_URL: string;
    }
}

export const SakModuleName = 'sak';
export const SakModuleNameLegacy = 'kundeportal/sak';

export const SakRoutes = {
    moduleRoute: () => generateRoute([SakModuleName]),
    list: () => generateRoute([SakModuleName]),
    add: () => generateRoute([SakModuleName, 'add']),
    confirmation: () => generateRoute([SakModuleName, 'confirmation']),
    single: (sakId?: string) => generateRoute([SakModuleName, sakId]),
    singleLegacy: (sakId?: string) =>
        generateRoute([SakModuleNameLegacy, sakId]),
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SakAccess = (_user?: User): boolean =>
    getConfig('WEBAPP_SAK_ENABLE', false);

export const SakMenuItems = [
    new SidebarMenuItem({
        route: SakRoutes.list(),
        matchRoute: SakRoutes.moduleRoute(),
        icon: IconName.GEAR,
        translation: 'frontPage.mytasksLink',
        access: SakAccess,
    }),
];
